import request from "@/utils/request";
// var host = "https://kids.zdapk.cn/";
var host = "";
// getConfig
export function configList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Home/config",
    data: params
  });
}
// getNavbar
export function headerTabs(params) {
  return request({
    method: "POST",
    url: host + "/Api/NavMenu/lists",
    data: params
  });
}
// getFooterNavbar
export function footerTabs(params) {
  return request({
    method: "POST",
    url: host + "/Api/NavMenu/footer_lists",
    data: params
  });
}
// homeList
export function homeIndex(params) {
  return request({
    method: "POST",
    url: host + "/Api/Home/index",
    data: params
  });
}
export function stateList(params) {
  return request({
    method: "POST",
    url: host + "/Api/State/lists",
    data: params
  });
}

export function shopList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Shop/lists",
    data: params
  });
}
// /policy/waiver
export function wavierInfo(params) {
  return request({
    method: "POST",
    url: host + "/Api/Wavier/info",
    data: params
  });
}
// /policy/playground-rules
export function RulesList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Rules/info",
    data: params
  });
}
// /pricing
export function pricingConfig(params) {
  return request({
    method: "POST",
    url: host + "/Api/PricingConfig/info",
    data: params
  });
}
// /pricing/pass
export function playPunchList(params) {
  return request({
    method: "POST",
    url: host + "/Api/PlayPunch/lists",
    data: params
  });
}
// /pricing/unlimited
export function UnlimitedList(params) {
  return request({
    method: "POST",
    url: host + "/Api/UnlimitedPass/lists",
    data: params
  });
}

export function PartyPackageList(params) {
  return request({
    method: "POST",
    url: host + "/Api/PartyPackage/lists",
    data: params
  });
}
export function galleryList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Gallery/lists",
    data: params
  });
}
export function jobList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Job/lists",
    data: params
  });
}
// /policy/privacy
export function policyPrivacy(params) {
  return request({
    method: "POST",
    url: host + "/Api/Policy/privacy",
    data: params
  });
}
// /policy/terms
export function policyTerms(params) {
  return request({
    method: "POST",
    url: host + "/Api/Policy/terms",
    data: params
  });
}
export function addWavier(params) {
  return request({
    method: "POST",
    url: host + "/Api/Wavier/user_add",
    data: params
  });
}
export function partyInfo(params) {
  return request({
    method: "POST",
    url: host + "/Api/BookParty/info",
    data: params
  });
}
// 支付
export function payInfo(params) {
  return request({
    method: "POST",
    url: host + "/Api/Stripe/pay_info",
    data: params
  });
}
// 公用页面
export function getPageContent(params) {
  return request({
    method: "POST",
    url: host + "/Api/Page/Content",
    data: params
  });
}


// WEBPACK FOOTER //
// ./src/server/api.js